module.exports = {
	"naslov": "Na straži",
	"slika": "fotke/1945/partizan_slovenija.jpg",
	"opis": "Ovo je samo proba da vidimo kako izgleda slika sa snegom."
};


//////////////////
// WEBPACK FOOTER
// ./src/hronologija/1945/01-01/podaci.json
// module id = 49
// module chunks = 0